import { IBaseListInputProps, BaseListInput } from "./BaseListInput";

import * as React from "react";
import { Guid } from "../Utils/Guid";
import * as $ from "jquery";
import AriaTooltip from "../../applications/Shared/Tooltip/AriaTooltip";

export interface IRadiosSpecificProps<TOption> extends IBaseListInputProps<TOption> {
    labelsHtmlFormatted?: boolean;
    ariaDescribedby?: string;
    ariaInvalidCanBeShown?: boolean;
    ariaInvalidShouldBeShown?: boolean;
    radioLabelCss?: string;
    optionsLabelCss?: string;
    selectedRadioCss?: string;
}

export interface IRadiosProps<TOption> extends IRadiosSpecificProps<TOption>, React.Props<Radios<TOption>> {
    // NOTE: leave empty
}

export class Radios<TOption> extends BaseListInput<TOption, IRadiosProps<TOption>> {
    private _inputRefs: HTMLInputElement[]; // TODO: Needed???

    private _grpName: string;

    constructor(props: IRadiosProps<TOption>) {
        super(props);
        this._inputRefs = new Array<HTMLInputElement>();
        this._grpName = "grp-name-" + Guid.getNext();
    }

    public componentDidMount(): void {
        this.setNamesOfAllInputs();
    }

    public componentDidUpdate(): void {
        this.setNamesOfAllInputs();
    }

    public render(): JSX.Element {
        return <ul className="rg-list controls-wrap">{this.getRadioButtons()}</ul>;
    }

    protected getSelectedOption(selectedIndex?: number): TOption {
        if (selectedIndex === null || selectedIndex === undefined) {
            const index = $("input[type=radio][name = " + this._grpName + "]:checked").val() as string;
            selectedIndex = index !== null && index !== undefined ? Globalize.parseInt(index) : -1;
        }

        if (selectedIndex < 0 || selectedIndex >= this.options.length) {
            return null;
        }

        return this.options[selectedIndex];
    }

    protected isHidden(): boolean {
        return $(this._inputRefs.filter((input) => input !== null)).is(":hidden");
    }

    private getRadioButtons(): JSX.Element[] {
        this._inputRefs = [];
        return this.options.map((option: TOption, index: number) => this.getOption(option, index));
    }

    private getOption(option: TOption, index: number): JSX.Element {
        const radioId: string = (this.props.id || this._grpName) + "_" + index.toString();

        return (
            <li className="rg-item" key={`option-${index}`}>
                <label
                    className={this.props.radioLabelCss ? this.props.radioLabelCss : "radio-button pin-radio"}
                    key={index}
                    htmlFor={radioId}
                >
                
                    <input
                        type="radio"
                        id={radioId}
                        checked={this.state.selectedIndex === index}
                        onChange={(event: React.SyntheticEvent) => this.onChange(event)}
                        onBlur={() => this.onBlur()}
                        className={this.props.cssInput ? this.props.cssInput : "rb-input"}
                        disabled={this.state.disable == true ? true : this.props.disabled}
                        value={index.toString()}
                        ref={(input: HTMLInputElement) => this._inputRefs.push(input)}
                        tabIndex={this.props.tabIndex}
                        aria-describedby={((!this.state.isValid || this.props.ariaInvalidShouldBeShown) &&
                            this.props.ariaInvalidCanBeShown) ? this.props.ariaDescribedby : ""}
                        aria-invalid={
                            (!this.state.isValid || this.props.ariaInvalidShouldBeShown) &&
                            this.props.ariaInvalidCanBeShown
                        }
                    />
                    <span
                        className={this.props.selectedRadioCss ? this.props.selectedRadioCss : "rb-design"}
                        aria-hidden="true"
                    />
                    {this.props.labelsHtmlFormatted ? (
                        <span
                            className={this.props.optionsLabelCss ? this.props.optionsLabelCss : "rb-label"}
                            dangerouslySetInnerHTML={{ __html: this.props.getText(option) }}
                        />
                    ) : (
                        <span className={this.props.optionsLabelCss ? this.props.optionsLabelCss : "label"}>
                            {this.props.getText(option)}
                        </span>
                    )}
                </label>
            </li>
        );
    }

    private setNamesOfAllInputs(): void {
        this._inputRefs.filter((input) => input !== null).forEach((input) => input.setAttribute("name", this._grpName));
    }
}
